import React from 'react';

import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { Messages } from '../../../../codegen/Localize';
import { SortableDataGrid } from '../../../../commonInfra/components/dataGrid/SortableDataGrid3';
import { SortableHeader } from '../../../../commonInfra/components/dataGrid/SortableHeader';
import { SliceableHelper } from '../../../../httpClient/utils/SliceableHelper';
import { ValueConceptValue } from '../../../types/ValueConcept';
import { highlightSearchTextCellFormatter } from '../../../utils/highlightSearchTextCellFormatter';
import { dataRoleSingleValueMatchesSearch, formatValue } from '../../../utils/searchUtils';

export interface LegacyDataRoleValuesListProps {
  readonly valuesList: ReadonlyArray<ValueConceptValue>;
  readonly isEditing: boolean;
  readonly filterText: string;
}

export const LegacyDataRoleValuesList = (props: LegacyDataRoleValuesListProps) => {
  const filteredValues = props.valuesList.filter(v => dataRoleSingleValueMatchesSearch(v, props.filterText));

  const filteredSortedValues = (orderClause: ReadonlyArray<IOrderClause>):  ReadonlyArray<ValueConceptValue> => {
    if(orderClause.length < 1 || orderClause[0].ascending) {
      return filteredValues;
    }
    return [...filteredValues].reverse();
  };

  const dataGridCols = [
    {
      ...dataGridBaseCol,
      headerText: Messages.dataRoleDefinitionSubspace_Values_Name(),
      cellFormatter: highlightSearchTextCellFormatter(props.filterText),
    }
  ];

  return (
    <SortableDataGrid
      columns={dataGridCols}
      getSliceable={getRowData((orderClause: ReadonlyArray<IOrderClause>) => filteredSortedValues(orderClause).map(formatValue))}
      getRowFromData={getRowFromData}
    />);
};

const getRowData = (getValueArray: (orderClause: ReadonlyArray<IOrderClause>) => ReadonlyArray<string>) =>
  (orderClause: ReadonlyArray<IOrderClause>) => SliceableHelper.fromArray([...getValueArray(orderClause)]);

const getRowFromData = (value: string)=> ({key: value, data: {name: value}});

const dataGridBaseCol = {
  name: 'name',
  dataKey: 'name',
  sortable: true,
  resizable: false,
  growToFit: true,
  headerFormatter: SortableHeader.Formatter(),
  direction: 'asc',
};
